import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { updateOnCompamyDirectorChanges } from '../utils/personaDetailsUtils';

const AuthorisedSignatory = ({ values, isEditMode }) => (
  <Content>
    {({
      globalRadioError = '',
      personDetailsAuthorisedSignatory = '',
      radioFieldYes,
      radioFieldNo,
      personDetailsAuthorisedSignatoryHelpText
    }) => (
      <Field
        name="authorisedSignatory"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="authorisedSignatory"
            title={personDetailsAuthorisedSignatory}
            description={personDetailsAuthorisedSignatoryHelpText}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="authorisedSignatory"
              items={[
                {
                  id: radioFieldYes,
                  labelText: radioFieldYes
                },
                {
                  id: radioFieldNo,
                  labelText: radioFieldNo
                }
              ]}
              {...input}
              selectedId={values.authorisedSignatory}
              onChange={selectedId => {
                if (isEditMode) {
                  updateOnCompamyDirectorChanges(selectedId);
                }
                input.onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default AuthorisedSignatory;
